import { Link } from "react-router-dom";
import { Satellite, Tv, Zap, Phone, Mail, Check, ChevronRight, Shield } from "lucide-react";

export default function TemplateClassic({ site }) {
  const { brand_name, color_primary, color_accent, color_nav, phone, email, products, headline, tagline } = site;
  const p = color_primary || "#185FA5";
  const a = color_accent || "#1D9E75";
  const n = color_nav || "#0C447C";
  return (
    <div className="min-h-screen bg-white font-body">
      {/* Nav */}
      <nav style={{ backgroundColor: n }} className="text-white">
        <div className="max-w-6xl mx-auto px-4 h-16 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Satellite className="w-6 h-6" />
            <span className="font-heading font-bold text-xl">{brand_name || "DTH Portal"}</span>
          </div>
          <div className="flex items-center gap-4 text-sm">
            <a href="#plans" className="hover:opacity-80">Plans</a>
            <a href="#about" className="hover:opacity-80">About</a>
            <Link to="login" style={{ color: n }} className="bg-white px-4 py-2 rounded-md font-semibold text-sm hover:bg-slate-100">Login</Link>
          </div>
        </div>
      </nav>

      {/* Hero */}
      <section style={{ background: `linear-gradient(to bottom, ${n}, ${p})` }} className="text-white py-20 px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="font-heading font-bold text-4xl md:text-6xl">{headline || "Recharge Your DTH in Seconds"}</h1>
          <p className="mt-4 text-blue-200 text-lg max-w-2xl mx-auto">
            {tagline || "Quick, secure, and reliable DTH recharge. Choose from our wide range of plans and enjoy uninterrupted entertainment."}
          </p>
          <div className="mt-8 flex flex-wrap gap-3 justify-center">
            <button style={{ color: n }} className="bg-white px-6 py-3 rounded-lg font-bold hover:shadow-lg transition-shadow flex items-center gap-2">
              <Zap className="w-5 h-5" /> Recharge Now
            </button>
            <a href="#plans" className="border border-white/40 px-6 py-3 rounded-lg font-semibold hover:bg-white/10">View Plans</a>
          </div>
          <div className="mt-6 flex justify-center gap-6 text-sm text-blue-200">
            <span className="flex items-center gap-1"><Check className="w-4 h-4" /> Instant Activation</span>
            <span className="flex items-center gap-1"><Shield className="w-4 h-4" /> 100% Secure</span>
          </div>
        </div>
      </section>

      {/* Plans */}
      <section id="plans" className="py-16 px-4">
        <div className="max-w-6xl mx-auto">
          <h2 style={{ color: n }} className="font-heading font-bold text-3xl text-center">Our Plans</h2>
          <p className="text-center text-slate-500 mt-2">Choose the perfect plan for your viewing needs</p>
          <div className="mt-10 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {(products || []).slice(0, 6).map((p, i) => (
              <div key={p.id || i} style={{ borderColor: p }} className="border rounded-xl p-6 shadow-sm hover:shadow-lg transition-all">
                <p className="text-xs text-slate-500 uppercase font-semibold">{p.category || p.operator}</p>
                <h3 style={{ color: n }} className="font-heading font-bold text-xl mt-1">{p.name}</h3>
                <p style={{ color: a }} className="font-heading font-bold text-3xl mt-3">₹{p.sell_price}</p>
                <p className="text-sm text-slate-500 mt-1">{p.validity_days} days • {p.channel_count || "All"} channels</p>
                {p.description && <p className="text-sm text-slate-500 mt-2">{p.description}</p>}
                <button style={{ backgroundColor: p }} className="mt-4 w-full text-white py-2.5 rounded-lg font-semibold hover:opacity-90 transition-opacity flex items-center justify-center gap-1">
                  Subscribe <ChevronRight className="w-4 h-4" />
                </button>
              </div>
            ))}
          </div>
          {(!products || products.length === 0) && (
            <p className="text-center text-slate-400 mt-8">No plans available yet. Check back soon!</p>
          )}
        </div>
      </section>

      {/* About */}
      <section id="about" className="py-16 px-4 bg-slate-50">
        <div className="max-w-4xl mx-auto text-center">
          <h2 style={{ color: n }} className="font-heading font-bold text-3xl">About {brand_name || "Us"}</h2>
          <p className="mt-4 text-slate-600 text-lg">
            Your trusted DTH service provider. We offer the best plans with instant activation and 24/7 customer support.
          </p>
          <div className="mt-8 flex flex-wrap justify-center gap-6">
            {phone && <a href={`tel:${phone}`} style={{ color: p }} className="flex items-center gap-2 font-semibold"><Phone className="w-5 h-5" />{phone}</a>}
            {email && <a href={`mailto:${email}`} style={{ color: p }} className="flex items-center gap-2 font-semibold"><Mail className="w-5 h-5" />{email}</a>}
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer style={{ backgroundColor: n }} className="text-white py-8 px-4">
        <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-2"><Satellite className="w-5 h-5" /><span className="font-heading font-bold">{brand_name || "DTH Portal"}</span></div>
          <div className="flex items-center gap-4 text-sm text-blue-200">
            <Link to="privacy-policy" className="hover:text-white transition-colors">Privacy Policy</Link>
            <p>© {new Date().getFullYear()} All rights reserved.</p>
          </div>
        </div>
        <div className="max-w-6xl mx-auto mt-8 pt-4 border-t border-white/20 text-center text-xs text-blue-200">
          Powered by : Oxiaim Techbreed Pvt. Ltd.
        </div>
      </footer>
    </div>
  );
}
